<template>
<div v-if="pageData" class="c-mv4" :class="{'c-mv4--modal': pageData.modal, 'c-mv4--vertical': isVertical, 'c-mv4--horizonal': !isVertical}">
  <div class="c-mv4__main" @click="openModal">
    <span class="is-shape" :style="styleShape"></span>
    <span class="is-wrap">
      <img :src="pageData.photo.src" alt="" />
    </span>
    <button v-if="pageData.modal" class="c-btnModal c-btnModal--rd">
      <span></span>
    </button>
  </div>
  <div v-if="pageData.info.title" class="c-mv4__info">
    <h2 :class="{'is-blend': isBlend}" :style="{'color': colorCode}">
      <span v-for="line in pageData.info.title" :key="line">
        <span class="is-line">{{line}}</span>
      </span>
    </h2>
  </div>
</div>
</template>

<script>
import {gsap, Power3, Expo} from 'gsap/all';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

export default {
  data() {
    return {
      pageData: null,
      modal: null,
      shapeSize: 1174 / 750 * 100,
      isVertical: false,
      isBlend: false,
      colorCode: '',
    }
  },
  props: ['name'],
  computed: {
    styleShape() {
      return {paddingTop: `${this.shapeSize}%`};
    }
  },
  mounted() {
    // ページデータ
    this.pageData = this.$store.getters.pageData[this.name];
    // モーダル
    this.modal = this.pageData.modal;

    // 画像 横or縦
    const img = new Image();
    img.onload = () => {
      this.loaded({width: img.width, height: img.height});
    }
    img.src = this.pageData.photo.src;

    // タイトル文字色設定
    if (this.pageData.info.color) {
      this.colorCode = `${this.pageData.info.color}`;
    } else {
      this.isBlend = true;
    }
  },
  methods: {
    once() {
      // 画像表示
      const photo = this.$el.querySelector('.c-mv4__main .is-wrap');
      let viewPhoto = gsap.timeline({
        scrollTrigger: {
          trigger: this.$el,
          start: 'top bottom',
          end: 'top 10%',
          once: true,
          scrub: true,
          // markers: true,
        }
      });

      viewPhoto.addLabel('start')
      .fromTo(photo, {
        scale: 1.3,
        y: '-50%',
      }, {
        duration: 1.0,
        scale: 1,
        y: '0%',
        ease: 'none',
      }, 'start');

      // テキスト表示
      const blockText = this.$el.querySelector('.c-mv4__info');
      if (blockText) {
        const lines = blockText.querySelectorAll('.is-line');
        let viewTitle = gsap.timeline({
          scrollTrigger: {
            trigger: blockText,
            start: 'top 70%',
            end: 'top 40%',
            once: true,
            // scrub: true,
            // markers: true,
          }
        });

        viewTitle
        .fromTo(lines, {
          y: '100%',
        }, {
          duration: 1.0,
          y: '0%',
          ease: Power3.easeOut,
          stagger: 0.1,
        });
      }
    },
    openModal() {
      this.$store.commit('setCurrentModal', this.$store.getters.modalData[this.modal]);
      this.$store.commit('setShowModal', true);
    },
    loaded(e) {
      if (e.width > e.height) {
        this.isVertical = false;
      } else {
        this.isVertical = true;
      }
      this.shapeSize = e.height / e.width * 100;
      this.$nextTick(this.once);
    },
  }
}
</script>